import {useParams} from 'react-router-dom';
import {DEFAULT_PROVIDER, getProvider, type Provider} from '@/config/providers';

/**
 * The provider for the current route.
 *
 * Every page that calls this renders under `ProviderLayout`, which redirects
 * unknown slugs before its children mount — so the fallback here is only for
 * type-safety, never a state the UI actually reaches.
 */
export function useCurrentProvider(): Provider {
  const {providerId} = useParams<{providerId: string}>();
  return getProvider(providerId) ?? DEFAULT_PROVIDER;
}
